import { CropVM } from "./crop";
import { CropScalesVM } from "./scale";

import m = omnia.models;

export class GroupVM {

    constructor(public readonly crop: CropVM, public readonly scales: CropScalesVM[]) {

    }

    get name(): string {
        return this.crop.name;
    }

    get id(): number {
        return this.crop.id;
    }

    getCropCssColor(): any {
        return this.crop.getCropCssColor()
    }

}
